// extracted by mini-css-extract-plugin
var _1 = "AdminProvisionsView-module__addNewWrapper--svOcM";
var _2 = "AdminProvisionsView-module__badgeWrapper--wge1I";
export { _1 as "addNewWrapper", _2 as "badgeWrapper" }
